import { apiRequest } from './client';
import { catalogConfig } from '../config/catalog';

export default async function createReport(id_sku, motive = "") {
  const params = {
    cnpj: catalogConfig.cnpj,
    motive: motive,
    id: id_sku,
  }
  
  return apiRequest('/report/v1/create_report', {
    method: 'POST',
    params,
  });
}
